import {Annotation} from './Annotation'

/**
 * Metadata for the component style property for the form builder.
 */
export class StyleAnnotation extends Annotation {
}
